import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components/macro'
import Head from '../components/layout/Head'
import Toast from '../components/layout/Toast'
import EnvironmentBanner from '../components/layout/EnvironmentBanner'
import LoadingIndicatorPage from '../components/layout/LoadingIndicatorPage'

const Page = styled('div')`
  box-sizing: border-box;
  display: flex;
  min-height: 100%;
`

const Content = styled('main')`
  flex-grow: 1;
  width: calc(100% - 324px);
`

const LayoutNavigation = ({ navigation }) => (
  <>
    <Head />
    <Toast />
    <Page>
      {navigation}
      <Content>
        <EnvironmentBanner />
        <Suspense fallback={<LoadingIndicatorPage />}>
          <Outlet />
        </Suspense>
      </Content>
    </Page>
  </>
)

export default LayoutNavigation
